module.exports = __webpack_public_path__ + "img/ms4aeco.27592afd.png";